import { render, staticRenderFns } from "./run-scene.vue?vue&type=template&id=19b38100&scoped=true&"
import script from "./run-scene.vue?vue&type=script&lang=ts&"
export * from "./run-scene.vue?vue&type=script&lang=ts&"
import style0 from "./run-scene.vue?vue&type=style&index=0&id=19b38100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b38100",
  null
  
)

export default component.exports